<template>
  <div id="datatable-document-primary-column">
      <span v-if="hasBeenChanged" class="d-flex justify-content-end">
        <a-tooltip :title="$t('refresh_to_see_changes')">
          <a-badge :count="messageCounter">
            <a-button shape="circle" size="small" class="mr-1" @click="$emit('onReload')">
              <a-icon type="reload"> </a-icon>
            </a-button>
          </a-badge>
        </a-tooltip>
      </span>
    <div
      class="d-flex align-items-center"
      style="gap: .5rem"
      :class="{ 'justify-content-between': isBoxMode }"
    >
      <div
        class="d-flex flex-column align-items-start mr-2"
        :class="{ 'p-3': isBoxMode }"
      >
        <span class="mb-2" :class="{ 'text-box-container': isBoxMode }">
          {{ value.name }}
        </span>
        <b-badge variant="info" class="pt-1" :class="`document-status-button color-${value.status.id}`">{{ value.status.name }}</b-badge>
      </div>
      <div class="d-flex" style="gap: .75rem" :class="{ 'align-self-start px-3': isBoxMode }">
        <CommentsIcon
          :id="value.id"
          v-bind="comments"
        />
        <MovementsIcon
          :id="value.id"
          v-bind="movements"
        />
        <TagsIcon
          v-if="showTags"
          :id="value.id"
          v-bind="tags"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
import lmDatatableComponentWebsocketMixin from '@/mixins/lmDatatableComponentWebsocketMixin.js'

// Components
import CommentsIcon from './components/CommentsIcon'
import MovementsIcon from './components/MovementsIcon'
import TagsIcon from './components/TagsIcon'

export default {
  mixins: [lmDatatableComponentWebsocketMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    comments: {
      type: Object
    },
    movements: {
      type: Object
    },
    tags: {
      type: Object
    },
    isBoxMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CommentsIcon,
    MovementsIcon,
    TagsIcon
  },
  computed: {
    showTags () {
      return process.env?.VUE_APP_DISABLE_TAGS !== 'yes'
    }
  }
}
</script>

<style lang="sass">
#datatable-document-primary-column
  .text-box-container
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    line-clamp: 2
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical
  .column-action-button
    width: 27px
    height: 27px
    border-radius: 50%
    padding: 4px
.datatables-comments-popover
  width: 400px
  max-width: 400px
  max-height: 400px
  .no-comments
    height: 335px
  .scroll
    height: calc(400px - 55px - 1.5rem)
    overflow-y: auto
    margin: 2px 0
    &:hover
      &::-webkit-scrollbar-thumb
        border-radius: 20px
        background: #888
    &::-webkit-scrollbar
      width: 8px
    &::-webkit-scrollbar-thumb
      border-radius: 20px
      background: transparent
    &::-webkit-scrollbar-thumb:hover
      background: #555
  .datetime-text
    font-size: .7rem
  #comments-message
    blockquote
      padding-left: 1rem
      border-left: 2px solid rgba(13, 13, 13, 0.1)
.mdi-bell-outline.animate-bell-icon:before
  animation: shake 1.5s forwards infinite

.document-status-button.color-2, .document-status-button:hover.color-2
  background-color: #007bff

.document-status-button.color-3, .document-status-button:hover.color-3
  background-color: #97077D

.document-status-button.color-4, .document-status-button:hover.color-4
  background-color: #6FB200

.document-status-button.color-6, .document-status-button:hover.color-6
  background-color: #00872A

.document-status-button.color-7, .document-status-button:hover.color-7
  background-color: rebeccapurple

.document-status-button.color-9, .document-status-button:hover.color-9
  background-color: red
</style>
